<template>
  <div class="modal-container">
    <div class="blur-backdrop" @click="close" />
    <div class="modal">
      <div class="title">
        Add Prompt to Prompt Pack
      </div>

      <div class="explanatory-text">
        Choose a pack to add this prompt to
      </div>

      <div class="pack-select-wrapper">
        <PromptPackCustomSelect
          v-model="selectedPromptPack"
          :options="promptPacks"
          :default="selectedPromptPack"
          noOptionsText="-- None --"
          style="margin-bottom: 0.8em;"
        />
      </div>

      <SpinnerButton
        class="button"
        :isDisabled="selectedPromptPack.promptPackName === null"
        :isProcessing="isAddingToPromptPack"
        @click="addPromptToPack"
      >
        Add to Prompt Pack
      </SpinnerButton>
      
      <SpinnerButton
        class="button danger"
        :isProcessing="isAddingToPromptPack"
        :showSpinner="false"
        @click="close"
      >
        Cancel
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import PromptPackCustomSelect from '@/components/utilComponents/PromptPackCustomSelect.vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'AddToPackModal',
  components: {
    PromptPackCustomSelect,
    SpinnerButton
  },
  props: {
    promptPackTable: Object,
    promptPacks: Array,
    promptSet: String,
    promptId: String
  },
  data: () => ({
    isAddingToPromptPack: false,
    selectedPromptPack: {}
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async addPromptToPack() {
      if (this.selectedPromptPack && this.promptSet && this.promptId) {
        try {
          this.isAddingToPromptPack = true;
          await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/addprompttopack`, {
            auth0UserId: this.auth0UserId,
            promptPackId: this.selectedPromptPack.promptPackId,
            promptSet: this.promptSet,
            promptId: this.promptId
          }, {
            headers: {
              'Content-Type': 'application/json', 
              'Authorization': `Bearer ${this.idToken}`
            }
          });
          this.isAddingToPromptPack = false;
        } catch (error) {
          console.log(error);
          console.log(error.body);
        }
      }
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
  created: function() {
    this.selectedPromptPack = this.promptPacks[0] || {promptPackId: null, promptPackName: null};
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';
</style>
